import { isClientSideRendered as n } from "../../utils/ssr.js";
var i = function i() {
  var i;
  var t, o;
  if (n()) {
    var _n = window.navigator;
    _n && (t = _n.userAgent, o = null !== (i = _n.userAgentData && _n.userAgentData.platform) && void 0 !== i ? i : null == _n ? void 0 : _n.platform);
  }
  var a = null;
  return -1 !== ["Macintosh", "MacIntel", "MacPPC", "Mac68K", "macOS"].indexOf(o) ? a = "osx" : -1 !== ["iPhone", "iPad", "iPod"].indexOf(o) ? a = "ios" : -1 !== ["Win32", "Win64", "Windows", "WinCE"].indexOf(o) ? a = "windows" : /Android/.test(t) ? a = "android" : !a && /Linux/.test(o) && (a = "linux"), a;
};
export { i as default };